
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { RANGER_SOURCE_MAP_METADATA } from './ranger-source-map.metadata';
import { RangerSourceMap } from './ranger-source-map.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class RangerSourceMapEntityDecoratorBase extends GenericEntityDecorator<RangerSourceMap, string> {
  constructor() {
    super(RANGER_SOURCE_MAP_METADATA, {
      get businessUnits(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentres(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.rangerSourceMapId == null) {
      return null;
    }
    return params.rangerSourceMapId;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: RangerSourceMap): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




